export const APPLICATION_STATUS = Object.freeze({
  SUBMITTED: "Submitted",
  DRAFTED: "Drafted",
  AWARDED: "Awarded",
  NOT_AWARDED: "Not awarded",
  VALIDATED: "Validated",
  RETURNED: "Returned",
  RETURN_TO_BANK: "Return",
  DISBURSED: "Disbursed",
});

export const APPLICATION_RESULT_STATUS = Object.freeze({
  TO_BE_AWARDED: "To be awarded",
  NOT_TO_BE_AWARDED: "Not to be awarded",
  EXCLUDED: "Excluded",
});

// Required file categories for Operating Bank Specialists to enable disbursement
// These categories must have 'is_required_for_operating_bank' flag set to true in the database
export const REQUIRED_OPERATING_SPECIALIST_FILE_CATEGORIES = Object.freeze({
  DISBURSEMENT_REQUEST: "Disbursement request",
  ON_LENDING_AGREEMENT: "On-lending agreement",
});
